import { render, staticRenderFns } from "./FluxoCaixa2Form.vue?vue&type=template&id=4a41b032&scoped=true&"
import script from "./FluxoCaixa2Form.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixa2Form.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixa2Form.vue?vue&type=style&index=0&id=4a41b032&scoped=true&lang=css&"
import style1 from "./FluxoCaixa2Form.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41b032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
